export default "__VITE_ASSET__CuVapw2Y__"